<template>
  <v-app>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  body {
    font-family: 'Raleway', sans-serif;
  }

  #app {
    background-color: #6fc2b5;
  }
</style>
